import React from "react";
import ContentPage from "../components/content-page";
import SEO from "../components/seo";
var ImprintPage = function ImprintPage(_ref) {
    var data = _ref.data;
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(SEO, {
        title: data.datoCmsImprint.title
    }), /*#__PURE__*/ React.createElement(ContentPage, {
        title: data.datoCmsImprint.title,
        content: data.datoCmsImprint.content
    }));
};
var query = "3687722660";
export default ImprintPage;
